import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Stepper: ComponentStyleConfig = {
  baseStyle: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    h: '40px',
    minW: '88px',
    p: '8px',
    backgroundColor: 'white',
    borderWidth: '1px',
    borderRadius: 'full',
    borderColor: 'neutral.500',
    _focusWithin: {
      borderColor: 'black',
    },
  },
  sizes: {
    sm: {
      h: '32px',
      p: '4px',
      minW: '72px',
      fontSize: 'sm',
      fontWeight: 500,
    },
    md: {
      h: '40px',
      p: '8px',
      minW: '88px',
      fontSize: 'md',
      fontWeight: 500,
    },
    lg: {
      h: '48px',
      p: '12px',
      minW: '112px',
      fontSize: 'lg',
      fontWeight: 500,
    },
  },
  defaultProps: {
    size: 'sm',
  },
};

export default Stepper;
